//generic labels for draft autosave states (see DraftAutosaveIndicator)
const saveStateTranslations = {
  saving: "Speichert",
  saved: "Gespeichert",
  error: "Speichern fehlgeschlagen",
};

export default saveStateTranslations;
